export * from './IconPolygonOrange';
